// AuthGuard.js

import React, { useState, useEffect } from 'react';
import API from './../api';
import { useDispatch, useSelector } from 'react-redux';
import { clearUser, fetchUser } from './../redux/userSlice';
import { updateUser } from './../redux/userSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import UserSignInModal from "../components/user/UserSignInModal";

const AdminGuard = ({ children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const location = useLocation();
  console.log(user)
  const [isReady, setIsReady] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [userModalOptions, setUserModalOptions] = useState({});

  useEffect(() => {
    // À remettre plus tard si nécessaire
    // API.get('/admin/user')
    //   .then(response => {
    //     dispatch(updateUser(response.data));
    //     setIsReady(true);
    //   })
    //   .catch(() => navigate('/'));

    setIsReady(true);
  }, [location]);

  useEffect(() => {
    if (isReady && user && !user.isAdmin) {
      dispatch(clearUser());
      navigate('/'); // ou /login selon ton routing
    }
  }, [user, isReady]);

  // Attente du check
  if (!isReady) {
    return null;
  }

  // Non-admin → modal
  if (!user.isAdmin) {
    return (
      <UserSignInModal
        show={showModal}
        options={userModalOptions}
        onClose={() => setShowModal(false)}
      />
    );
  }

  // Admin → accès autorisé
  return children;
};

export default AdminGuard;
